export const OFFLINE_PREFIX_CONFIG = [
  { prefix: "BD", totalPages: 54 },
  { prefix: "HG", totalPages: 15 },
  { prefix: "LS", totalPages: 82 },
  { prefix: "WF", totalPages: 52 },
  { prefix: "YO", totalPages: 60 },
] as const;

export const OFFLINE_PREFIXES = OFFLINE_PREFIX_CONFIG.map(({ prefix }) => prefix);

export type Prefix = (typeof OFFLINE_PREFIX_CONFIG)[number]["prefix"];

export const TOTAL_PAGES: Record<Prefix, number | null> = Object.fromEntries(
  OFFLINE_PREFIX_CONFIG.map(({ prefix, totalPages }) => [prefix, totalPages])
) as Record<Prefix, number | null>;

export function isOfflinePrefix(prefix: string): prefix is Prefix {
  return OFFLINE_PREFIXES.includes(prefix as Prefix);
}
